import { proxyApi } from './common'
import { axios } from './config'
async function ticketApi(target, data) {
    return proxyApi('ticket', target, data)
}

/**
 *查询审核记录
 *
 * @param {*} { projectId, index, size, statusId }
 * @returns
 */
async function GetAuditList({
    projectId,
    index,
    size,
    statusId,
    statusIds,
    staffId,
    q,
    all
}) {
    return await ticketApi('auditList', {
        projectId,
        index,
        size,
        statusId,
        statusIds,
        staffId,
        q,
        all
    })
}
async function GetTicketDetail({
    projectId,
    ticketNumber,
    withLogs = true,
    logTypes
}) {
    return await ticketApi('detail', {
        projectId,
        ticketNumber,
        withLogs,
        logTypes
    })
}

/**
 *新纪录
 *
 * @param {*} projectId
 * @param {*} ticketNumber
 * @param {*} nextLog 最新logid
 * @param {*} staffId
 * @param {*} logTypes 根据type过滤
 * @returns
 */
async function GetNewLogs({
    projectId,
    ticketNumber,
    nextLog,
    staffId,
    logTypes
}) {
    return await ticketApi('newLogs', {
        projectId,
        ticketNumber,
        nextLog,
        staffId,
        logTypes
    })
}
/**
 *
 *
 * @param {*} { projectId, nextLogs:{"{ticketNumber}":"{nextLogId}"} ,logTypes}
 * @returns
 */
async function GetNewLogNumber({ projectId, nextLogs, logTypes }) {
    return await ticketApi('newLogNumbers', {
        projectId,
        nextLogs,
        logTypes
    })
}
/**
 *查询工单模块参数
 *
 * @param {*} projectId
 * @returns
 */
async function GetProjectDetail(projectId) {
    return await ticketApi('project', { projectId })
}

/**
 *查询提交记录
 *
 * @param {*} {projectId,index,size,statusId}
 * @returns
 */
async function GetSubmitList({
    projectId,
    index,
    statusIds,
    size,
    statusId,
    q
}) {
    return await ticketApi('submitList', {
        projectId,
        statusIds,
        index,
        size,
        statusId,
        q
    })
}
/**
 *查询可变更状态
 *
 * @param {*} projectId
 * @param {*} ticketNumber
 * @returns
 */
async function GetAvailableStatus(projectId, ticketNumber) {
    return await ticketApi('available', { projectId, ticketNumber })
}
/**
 *
 *
 * @param {*} form  {
    projectId : "{projectId}"
    ticketNumber: "{tikcetNumber}",
    statusId:"{statusId}",
    auditorIds:["{auditorId}"],
    remark:"{remark}"
    staffId:"{staffId}"
}
 * @returns
 */
async function PutTransition(form) {
    return await ticketApi('transition', form)
}
/**
 *查询用户角色
 *
 * @param {*} projectId
 * @returns
 */
async function GetRole(projectId) {
    return await ticketApi('role', { projectId })
}
/**
 *回复工单
 *
 * @param {*} reply {projectId,ticketNumber,content,detail ,staffId}
 * @returns
 */
async function Reply(reply) {
    return await ticketApi('reply', reply)
}
/**
 *获取上传签名
 *
 * @param {*} projectId
 * @param {*} ticketNumber
 * @returns
 */
async function GetUploadSignature(projectId, ticketNumber) {
    return await ticketApi('upload', { projectId, ticketNumber })
}
/**
 *获取工单下对应角色的员工
 *
 * @param {*} projectId
 * @param {*} role
 * @returns
 */
async function GetAvailableAuditor(projectId, role) {
    return await ticketApi('availableAuditor', { projectId, role })
}
/**
 *
 *
 * @param {*} body {projectId,ticketNumber,name,value,remark,staffId }
 * @returns
 */
async function ChangeParameters(body) {
    return await ticketApi('change', body)
}
/**
 *图片上传
 *
 * @param {*} signature
 * @param {*} file
 * @returns
 */
async function Upload(signature, file) {
    const formData = new FormData()
    for (let [k, v] of Object.entries(signature)) {
        formData.append(k, v)
    }
    formData.append('file', file)
    return await axios.post(signature.requestUri, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
export {
    GetAuditList,
    GetTicketDetail,
    GetRole,
    GetProjectDetail,
    GetAvailableStatus,
    GetSubmitList,
    Reply,
    GetUploadSignature,
    Upload,
    PutTransition,
    GetNewLogs,
    GetAvailableAuditor,
    ChangeParameters,
    GetNewLogNumber
}
